import {whenDomReady} from "../utils/when-dom-ready";

function registerHandlers() {
  // Get the cookie bar element
  const cookieBar = document.querySelector('.js-CookieBar');

  // If no element is found, then we don't need any cookie bar logic.
  if (!cookieBar) {
    return;
  }

  // Ensure that the element has the required attributes set on it:
  const acceptCookie = cookieBar.dataset.cookieAccept;
  const revokeCookie = cookieBar.dataset.cookieRevoke;

  if (!acceptCookie || !revokeCookie) {
    // Cookie banner has not been configured properly, so exit early
    return;
  }

  // Get the child form element:
  const formElement = cookieBar.querySelector("form");

  // Intercept the form submit handler, so we can set the cookie status without requiring a redirect.
  formElement.addEventListener("submit", (e) => {
    e.preventDefault();

    // Work out which button was clicked:
    const isAccept = e.submitter.value === "true";

    // Set the cookie
    document.cookie = isAccept ? acceptCookie : revokeCookie;

    // Fire an event on the window, so that other systems (e.g. GTM) are notified of a consent status change.
    const event = new CustomEvent('consentUpdate', { detail: isAccept });
    window.dispatchEvent(event);

    // Finally, hide the banner
    cookieBar.style.display = "none";
  });
}

whenDomReady(registerHandlers);